(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment contact-info-add
    module.directive('agendaAppointmentContactAdditionalInfoAdd',
        ['ContactInfo', 'AgendaBroadcast', 'AppointmentAdditionalInfo', 'ContactInfoService',
        function (ContactInfo, AgendaBroadcast, AppointmentAdditionalInfo, ContactInfoService) {
            var directive = {
                restrict: 'E',
                templateUrl: '/app/agenda/templates/agenda-appointment-contact-additional-info-add.template.html',
                scope: {
                    additionalInfoTypes: '='
                },
                link: link
            };
            return directive;

            function link(scope, element) {

                activate();

                // activate
                function activate() {
                    scope.types = ContactInfoService.data.contactinfotypes;
                } // activate

                // add new type
                scope.addType = function (type) {
                    // new contact info object
                    var info = new ContactInfo();
                    info.init(type);

                    // inform listener
                    scope.$emit(AgendaBroadcast.AddContactInfo, info);
                };

                // add new additional info
                scope.addAdditionalInfo = function (additional) {
                    var ai = new AppointmentAdditionalInfo();
                    ai.init(additional);
                    // inform listener
                    scope.$emit(AgendaBroadcast.AddAdditionalInfo, ai);
                };

            }

        }]);

})();